//
//
//
//
//

export default {
  name: 'CycleListItem'
}
